export function mapValueToRange({
  value,
  minValue,
  maxValue,
  minRange,
  maxRange,
}: {
  value: number;
  minValue: number;
  maxValue: number;
  minRange: number;
  maxRange: number;
}) {
  if (minValue === maxValue) {
    return minRange;
  }

  return ((value - minValue) * (maxRange - minRange)) / (maxValue - minValue) + minRange;
}

export function calculateRelativePercent({value1, value2, percent}: {value1: number; value2: number; percent: number}) {
  const max = Math.max(value1, value2);
  const min = Math.min(value1, value2);

  return (min / max) * percent;
}
